import api from '@edu-fe/api'

const module = {
  name: 'category',

  get: api.create(`/category/categories?client=2`)
}

export default module
